/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliCreateInstitutionGradeDto } from '../../models/amoxcalli-create-institution-grade-dto';
import { AmoxcalliInstitutionGradeDtoApiResponse } from '../../models/amoxcalli-institution-grade-dto-api-response';

export interface ApiInstitutionGradesPost$Json$Params {
      body?: AmoxcalliCreateInstitutionGradeDto
}

export function apiInstitutionGradesPost$Json(http: HttpClient, rootUrl: string, params?: ApiInstitutionGradesPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliInstitutionGradeDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiInstitutionGradesPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliInstitutionGradeDtoApiResponse>;
    })
  );
}

apiInstitutionGradesPost$Json.PATH = '/api/institution-grades';
